var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BlogPostList from '@marketing/components/navigation/BlogPostList';
import MenuItemList from '@marketing/components/navigation/MenuItemList';
import MoreInfo from '@marketing/components/navigation/MoreInfo';
import NavigationLink from '../NavigationLink';
function LearnMore(_a) {
    var onBack = _a.onBack, content = _a.content;
    var faqLibraryRoute = content.faqLibraryRoute, blogRoute = content.blogRoute, helpRoute = content.helpRoute, contactRoute = content.contactRoute;
    return (_jsxs("div", { children: [_jsxs("div", __assign({ className: "w-full flex flex-col justify-start items-start gap-[30px]" }, { children: [_jsx(NavigationLink, { label: "Learn More", direction: "left", useIcon: true, onClick: onBack }), _jsxs("div", __assign({ className: "flex flex-col justify-start items-start gap-2xs-gutter" }, { children: [_jsx(MenuItemList, { menuItems: [
                                    { displayName: 'FAQ Library', url: faqLibraryRoute },
                                    { displayName: 'Nom Nom Blog', url: blogRoute, isExternalLink: true },
                                ] }), _jsx(MoreInfo, { helpRoute: helpRoute, contactRoute: contactRoute })] }))] })), _jsx("div", __assign({ className: "mt-9 w-full pb-3" }, { children: _jsx(BlogPostList, {}) }))] }));
}
export default LearnMore;
